__turbopack_context__.v({
  "action": "newCalculator-module-scss-module__KB8mYG__action",
  "activeSummaryLeft": "newCalculator-module-scss-module__KB8mYG__activeSummaryLeft",
  "activeSummaryRight": "newCalculator-module-scss-module__KB8mYG__activeSummaryRight",
  "body": "newCalculator-module-scss-module__KB8mYG__body",
  "bodyBottomLeft": "newCalculator-module-scss-module__KB8mYG__bodyBottomLeft",
  "bodyBottomRight": "newCalculator-module-scss-module__KB8mYG__bodyBottomRight",
  "bodyChart": "newCalculator-module-scss-module__KB8mYG__bodyChart",
  "bodyExtraButton": "newCalculator-module-scss-module__KB8mYG__bodyExtraButton",
  "bodyPaymentPlan": "newCalculator-module-scss-module__KB8mYG__bodyPaymentPlan",
  "bodyTopLeft": "newCalculator-module-scss-module__KB8mYG__bodyTopLeft",
  "bodyTopRight": "newCalculator-module-scss-module__KB8mYG__bodyTopRight",
  "bodyTopSwitch": "newCalculator-module-scss-module__KB8mYG__bodyTopSwitch",
  "container": "newCalculator-module-scss-module__KB8mYG__container",
  "header": "newCalculator-module-scss-module__KB8mYG__header",
  "headerRow": "newCalculator-module-scss-module__KB8mYG__headerRow",
  "mobileHidden": "newCalculator-module-scss-module__KB8mYG__mobileHidden",
  "showMoreButton": "newCalculator-module-scss-module__KB8mYG__showMoreButton",
  "summaryImage": "newCalculator-module-scss-module__KB8mYG__summaryImage",
  "summaryImageActive": "newCalculator-module-scss-module__KB8mYG__summaryImageActive",
  "title": "newCalculator-module-scss-module__KB8mYG__title",
  "wrap": "newCalculator-module-scss-module__KB8mYG__wrap",
});
